<template>
    <input
        type="text"
        ref="inputElement"
        :value="modelValue"
        @input="updateValue"
        @keyup="handleKeyup"
        @change="handleChange"
        @focus="handleFocus"
        @blur="handleBlur"
    />
</template>

<script>
import { ref, watch, onMounted } from 'vue';

export default {
    props: {
        modelValue: String,
        live_mode: Boolean,
        leading_zero: {
            type: Boolean,
            default: true
        }
    },
    setup(props, { emit }) {
        const inputElement = ref(null);

        const updateValue = (event) => {
            emit('update:modelValue', event.target.value || null);
        };

        const formatMinutes = ([minutes, seconds = '00']) => `${minutes}:${seconds.substring(0, 2)}`;

        const sanitizeInput = (value) => {
            return value.replace(/[^0-9:]/g, "");
        };

        const ensureLeadingZero = (value) => {
            return props.leading_zero && value.length === 1 ? `0${value}` : value;
        };

        const handleKeyup = (event) => {
            let value = sanitizeInput(event.target.value);

            if (!value) {
                emit('update:modelValue', null);
                return;
            }

            let [minutes, seconds] = value.split(':');

            if (!minutes) value = `00:${seconds || '00'}`;
            if (seconds && seconds.length > 2) value = formatMinutes([minutes, seconds]);

            event.target.value = value;
            emit('update:modelValue', value);
        };

        const handleChange = (event) => {
            let value = sanitizeInput(event.target.value);

            if (!value) {
                emit('update:modelValue', null);
                return;
            }

            let [minutes = '00', seconds = '00'] = value.split(':');

            minutes = ensureLeadingZero(minutes);
            seconds = ensureLeadingZero(seconds);

            emit('update:modelValue', `${minutes}:${seconds}`);
        };

        const handleFocus = (event) => {
            if (event.target.value === '0:00') {
                emit('update:modelValue', event.target.value);
            }
        };

        const handleBlur = (event) => {
            let value = event.target.value;

            if (!value) {
                emit('update:modelValue', null);
                return;
            }

            let [minutes, seconds] = value.split(':');

            if (seconds && seconds.length > 2) {
                emit('update:modelValue', formatMinutes([minutes, seconds]));
            }
        };

        onMounted(() => {
            if (inputElement.value) {
                inputElement.value.value = props.modelValue || '';
                handleChange({ target: inputElement.value });
            }
        });

        watch(() => props.modelValue, (newValue) => {
            if (inputElement.value) {
                inputElement.value.value = newValue || '';
            }
        });

        return {
            inputElement,
            updateValue,
            handleKeyup,
            handleChange,
            handleFocus,
            handleBlur
        };
    }
};
</script>